import module from 'viaticos/module.js'
import template from './template.html'

export class viaticosSharedItemStatusComponent {
  data

  $onInit () {
    this.leyenda = this.data.posicion < this.data.maximo
      ? 'En proceso de autorización ' + (this.data.posicion + 1) + ' de ' + this.data.maximo
      : 'Autorizado, pendiente de pago'
  }
}

module.component('viaticosSharedItemStatus', {
  controller: viaticosSharedItemStatusComponent,
  template,
  bindings: {
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/item/status/component.js